import { Plugin } from 'vite'
import fs from 'fs'
import path from 'path'

/**
 * Vite 插件：複製 favicon.ico 到指定輸出目錄
 * @param customOutputDir {string} 可選，自定義輸出目錄（會覆蓋 Vite options.dir）
 * @param customFaviconPath {string} 可選，自定義 favicon 檔案來源路徑
 * @return {Plugin}
 */
const copyFaviconPlugin = (
	customOutputDir?: string,
	customFaviconPath?: string,
): Plugin => ({
	name: 'copy-favicon-plugin',
	/**
	 * Vite 插件：建置開始時觸發
	 * @return {void}
	 */
	buildStart(): void {
		console.log('🛠️ 準備複製 favicon.ico 到建置目錄...')
	},
	/**
	 * Vite 插件：寫入 bundle 時觸發
	 * @param options Vite 的 Rollup 選項
	 * @return {void}
	 */
	writeBundle(options): void {
		//取得輸出目錄
		const outputDir = customOutputDir || options.dir || 'dist'
		// 取得 favicon 檔案來源路徑
		const faviconSource =
			customFaviconPath ||
			path.resolve(
				__dirname,
				'../../shared-assets/src/images/favicon/logo.ico',
			)
		const faviconDest = path.resolve(outputDir, 'favicon.ico')

		try {
			if (!fs.existsSync(faviconSource)) {
				console.warn('⚠️ 找不到 favicon 檔案：', faviconSource)
				return
			}

			fs.mkdirSync(path.dirname(faviconDest), { recursive: true })
			fs.copyFileSync(faviconSource, faviconDest)

			console.log(`✅ 已複製 favicon.ico 到 ${faviconDest}`)
		} catch (error) {
			console.error('❌ 複製 favicon.ico 發生錯誤:', error)
		}
	},
})

export default copyFaviconPlugin
